<template>
  <div>
    <div class='home__eyecatch'>
      <h2>
        社交辞令ではない<br/>
        <strong>「また今度めし行きましょう」</strong><br />
        のために
      </h2>
      <a class="button-red" @click="login">Twitterアカウントでメイシを作る</a>
    </div>
    <div class='home__block'>
      <h3>めしメイシとは</h3>
      <p>めしメイシは、名刺交換をした初対面の人とまた今度めしにいくまでの約束を簡単にするためのWebサービスです。</p>
      <p>勉強会などで面白い人に出会えてもなかなかその場ではゆっくり話せなかったり、また会いたいと思ってもなんとなく流れてしまったりといったことは誰しも経験はあると思います。</p>
      <p>めしメイシを使うと、簡単に次めしにいく約束をすることができます。</p>
    </div>
    <div class='home__button'>
      <a class="button-red" @click="login">Twitterアカウントでメイシを作る</a>
    </div>
    <div style="background: #eee">
    <div class='home__block'>
      <h3>めしメイシの使い方</h3>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-xsmall-size-100">
          <h4><span>1</span>めしに行ける日を登録</h4>
          <img src='/static/images/step1.png' class='home__step-image'>
          <p>あらかじめめしに行ける日の候補日を入れておきます。</p>
        </div>
        <div class="md-layout-item md-xsmall-size-100">
          <h4><span>2</span>めしメイシを配る</h4>
          <img src='/static/images/step2.png' class='home__step-image'>
          <p>めしメイシから発行したQRコードシールを名刺の裏に貼り付け名刺交換します。</p>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-xsmall-size-100">
          <h4><span>3</span>めしに行ける日を選ぶ</h4>
          <img src='/static/images/step3.png' class='home__step-image'>
          <p>めしメイシをもらった人は、読み取ったQRコードからめしに行ける日を選びます。</p>
        </div>
        <div class="md-layout-item md-xsmall-size-100">
          <h4><span>4</span>めしに行く</h4>
          <img src='/static/images/step4.png' class='home__step-image'>
          <p>選ばられた日にtwitterのDMで連絡をとりつつめしに行きます。</p>
        </div>
      </div>
    </div>
    </div>
    <div class='home__block'>
      <h3>なぜめしメイシを使うとめしに行けるのか</h3>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-xsmall-size-100">
          <h4>自動相互フォロー</h4>
          <p>めしメイシでは、QRコードを読み込むだけで、twitterの相互フォローを実現します。</p>
          <p>これにより初対面の人と名刺交換をしたあとの連絡手段を確立します。</p>
        </div>
        <div class="md-layout-item md-xsmall-size-100">
          <h4>日程調整の簡略化</h4>
          <p>「また今度めし行きましょう」を実現するためのもっとも確実な手段は行く日を決めてしまうことです。</p>
          <p>めしメイシを使うことによって何より先に予定を確保します。予定さえ決まれば後はなんとかなります。</p>
        </div>
      </div>
    </div>
    <div class='home__button'>
      <a class="button-red" @click="login">Twitterアカウントでメイシを作る</a>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import firebaseApp from '../firebaseApp'
import router from '@/router'
const provider = new firebase.auth.TwitterAuthProvider()
const db = firebaseApp.firestore()
db.settings({ timestampsInSnapshots: true })

export default {
  methods: {
    login: function () {
      firebase.auth().signInWithPopup(provider).then(function (result) {
        const user = result.user
        console.log(user)
        const usersRef = db.collection('users').doc(user.uid)
        if (result.credential) {
          usersRef.set({name: user.displayName, photoUrl: user.photoURL, token: result.credential.accessToken, secret: result.credential.secret}, { merge: true })
            .then(function () {
              router.push({name: 'Mypage'})
            })
        } else {
          usersRef.set({name: user.displayName, photoUrl: user.photoURL}, { merge: true })
            .then(function () {
              router.push({name: 'Mypage'})
            })
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.home__eyecatch
  background-image: url('/static/images/eyecatch.jpg')
  background-size: cover
  background-position: center
  padding: 150px 10px
  text-align: center
  h2
    font-size: 25px
    line-height: 2em
    text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black
    color: white
    margin-bottom: 20px
    strong
      font-size: 45px
.home__block
  max-width: 800px
  padding: 20px
  margin: auto
  h3
    font-size: 20px
    line-height: 2em
    text-align: center
  h4
    font-size: 18px
    line-height: 40px
    span
      text-align: center
      font-size: 25px
      font-weight: bold
      border: 1px solid
      width: 40px
      height: 40px
      display: inline-block
      line-height: 40px
      margin-right: 10px
  p
    font-size: 15px
    line-height: 1.5em
.home__step-image
  width: 200px
  margin: auto
  display: block
.home__step-text
  text-align: center
.home__button
  text-align: center
  padding: 20px 20px 50px
.button-red
  padding: 20px
  font-size: 20px
  color: white !important
  background: #c30e24
  cursor: pointer
  display: inline-block
  &:hover
    text-decoration: none
    opacity: 0.8
    color: white !important
  &:visited
    color: white !important
</style>



// WEBPACK FOOTER //
// src/components/Home.vue